import React from "react";

import { BucketArchiveListingProvider } from "../context/BucketArchiveListingProvider";
import { BucketArchiveListing } from "./BucketArchiveListing";

export const BucketArchiveListingDashboard: React.VFC = () => (
    <BucketArchiveListingProvider>
        <BucketArchiveListing />
    </BucketArchiveListingProvider>

);
